export enum colors {
  red = "#E32E39",
  redLight = "#FFA6AB",
  green = "#00AA72",
  greenLight = "#A3CFC1",
  yellow = "#FFB831",
  yellowLight = "#FFE3AE",
  blue = "#1277ED",
  blueLight = "#9DC4F1",
  extraBlack = "#1A1A1A",
  black = "#262626",
  blackLight = "#262626E6", // E6 = 90%s
  grey1 = "#333333",
  grey2 = "#404040",
  grey3 = "#4C4C4C",
  grey4 = "#808080",
  grey5 = "#BFBFBF",
  grey6 = "#EEEEEE",
  white = "#ffffff",
  white5 = "#ffffff0C", // 0C = 5%
}
